import {
  Box,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormLabel,
  Radio,
  RadioGroup,
  TextField,
} from "@mui/material";
import { SmartAutoComplete } from "@nodeon/react-components";
import React from "react";
import { Controller, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useDropdownOptions } from "../hooks/useDropdownOptions";
import { SearchFormData } from "../tabs/SecurityDeviceSearchTab";
import { SharedFormProps } from "../WaterTrafficSignContainers/WaterTrafficSignStateForm";

export type StateAndTypeFormTypes = {
  sdIdentifier: string;
  deviceState: string[];
  subType: string;
  remoteMonitoring: boolean;
  type: string | null;
};

export const stateAndTypeFormDefaults: StateAndTypeFormTypes = {
  sdIdentifier: "",
  deviceState: [],
  subType: "",
  remoteMonitoring: false,
  type: null,
};

export const StateAndTypeForm = ({ isDisabled }: SharedFormProps) => {
  const { t } = useTranslation("fairwayReport");
  const { register, control } = useFormContext<StateAndTypeFormTypes>();
  const deviceStateOptions = React.useMemo(
    () => [
      { label: t("atonUnitStateForm:muutoksenAlainen"), value: "muutoksen" },
      { label: t("atonUnitStateForm:poistonAlainen"), value: "poiston" },
      { label: t("atonUnitStateForm:uusiAihio"), value: "uusi" },
      { label: t("atonUnitStateForm:poistettu"), value: "poistettu" },
      { label: t("atonUnitStateForm:vahvistettu"), value: "vahvistettu" },
      { label: t("atonUnitStateForm:poistoaihio"), value: "poistoaihio" },
    ],
    [t],
  );
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: "10px",
      }}
    >
      {/* <Typography>{t("fairwayReport:deviceIdOrName")}</Typography> */}
      <TextField
        disabled={isDisabled}
        {...register("sdIdentifier", { required: false })}
        label={t("fairwayReport:deviceIdOrName")}
      />

      <FormControl
        disabled={isDisabled}
        sx={{ display: "flex", flexDirection: "column" }}
      >
        <FormLabel>{t("state")}</FormLabel>
        <FormGroup sx={{ display: "flex", flexDirection: "row", gap: "9px" }}>
          <Controller
            control={control}
            name="deviceState"
            render={({ field }) => (
              <>
                {deviceStateOptions.map((option) => (
                  <FormControlLabel
                    key={option.value}
                    label={option.label}
                    control={
                      <Checkbox
                        value={option.value}
                        // For some reason codesandbox doesn't support `field.value.includes(...)`
                        checked={field.value.some(
                          (existingValue) => existingValue === option.value,
                        )}
                        onChange={(event, checked) => {
                          if (checked) {
                            field.onChange([
                              ...field.value,
                              event.target.value,
                            ]);
                          } else {
                            field.onChange(
                              field.value.filter(
                                (value) => value !== event.target.value,
                              ),
                            );
                          }
                        }}
                      />
                    }
                  />
                ))}
              </>
            )}
          />
        </FormGroup>
      </FormControl>
      <FormControl disabled={isDisabled}>
        <FormLabel>{t("fairwayReport:variant")}</FormLabel>
        <Controller<StateAndTypeFormTypes>
          name="subType"
          control={control}
          render={({ field }) => (
            <RadioGroup
              sx={{ display: "flex", flexDirection: "row" }}
              {...field}
            >
              <FormControlLabel
                value=""
                control={<Radio />}
                label={t("faultSearch:kaikki")}
              />
              <FormControlLabel
                value="Kiinteä"
                control={<Radio />}
                label={t("solid")}
              />
              <FormControlLabel
                value="Kelluva"
                control={<Radio />}
                label={t("kelluva")}
              />
            </RadioGroup>
          )}
        />
      </FormControl>
      {/* <SmartCheckbox<StateAndTypeFormTypes>
        label={t("securityDeviceSearch:kaukovalvonta")}
        name="remoteMonitoring"
        controllerProps={{ control }}
        disabled={isDisabled}
      /> */}
      <TypeSelect isDisabled={isDisabled} />
    </Box>
  );
};

export function TypeSelect({ isDisabled }: SharedFormProps) {
  const { control } = useFormContext<SearchFormData>();
  const { searchResult } = useDropdownOptions();
  const { t } = useTranslation("fairwayReport");

  return (
    <SmartAutoComplete<SearchFormData, string, false>
      disabled={isDisabled}
      name="type"
      label={t("type")}
      options={searchResult?.types ?? []}
      controllerProps={{ control }}
      // isOptionEqualToValue={(option, v) => {
      //   console.log)
      //   v === "" || v === option;
      // }}
      renderInput={(props) => <TextField label={t("type")} {...props} />}
    />
    // <SmartSelect<SearchFormData>
    //   disabled={isDisabled}
    //   name="type"
    //   label={t("type")}
    //   options={typeOptions}
    //   controllerProps={{ control }}
    // />
  );
}
